import * as React from 'react';

export type ShowInterface = {
  show?: boolean;
};

/**
 * Dynamic showing or hiding of a component.
 *
 * Designed for use with components that do not implement their own show or hide.
 * Does not pass on `show` prop.
 */
export const withShow =
  <P extends {}>() =>
  (WrappedComponent: React.ComponentType<P>): React.ComponentType<P & ShowInterface> => {
    return class Wrapper extends React.Component<P & ShowInterface> {
      static displayName = `withShow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

      render() {
        const { show, ...props } = this.props;
        if (show) {
          // Working around spread props typing issues when we want to omit a prop.
          return <WrappedComponent {...(props as P)} />;
        } else {
          return null;
        }
      }
    };
  };

export default withShow;
